<template>
    <div style="width:100%; max-width: 180px;">
        <v-select
            v-model="color"
            :items="colorOptions"
            item-text="label"
            item-value="value"
            :label="Translate('Format')"
            outlined
            dense
            class="ml-2 mr-3"
            background-color="white"
            hide-details
            :rules="colorRules"
            :error-messages="colorErrorMessages"
            :error="colorErrorMessages.length > 0" >

            <template v-slot:selection="{ item }">
            <div class="d-flex align-center">
                <div class="color-swatch mr-2" :style="{ backgroundColor: item.value }"></div>
                <span>{{ item.label }}</span>
            </div>
            </template>

            <template v-slot:item="{ item }">
            <div class="d-flex align-center">
                <div class="color-swatch mr-2" :style="{ backgroundColor: item.value }"></div>
                <span>{{ item.label }}</span>
            </div>
            </template>
        </v-select>
    </div>
</template>
    
<script>
    import methods from '@/Shared/methods';

    export default {
        data: function () {
            return {               
                color:'',                
                colorErrorMessages: [],
                hasColorError: false,
            }
        },
        props: {
            defaultColor: null,
            EventBus: null
        },
        created() {
                this.color = this.defaultColor;     
            },
        watch: {
            
            'color': {
                handler() {
                    if(this.color !== this.defaultColor)
                        this.triggerValidation();

                    this.$emit('thresholdFormatChanged', {
                        color: this.color
                    });
                }
            }
        },
        computed:{
            colorOptions() {
                return [
                    { label: this.Translate('Green'), value: '#4AB574' },
                    { label: this.Translate('Orange'), value: '#E07A1A' },
                    { label: this.Translate('Red'), value: '#EF4A41' },
                ];
            },
            colorRules() {
                return [
                    v => !!v || this.Translate('Please select a value')
                ];
            },
        },        
        methods: {
            ...methods,
            triggerValidation() {
                this.colorErrorMessages = [];
                for (const rule of this.colorRules) {
                    const result = rule(this.color);
                    if (typeof result === 'string') {
                        this.colorErrorMessages.push(result);
                        break; // Stop at the first error
                    }
                }      
            },            
        }
    }
</script>

<style scoped>
    .color-swatch {
        width: 20px;  /* Adjust size as needed */
        height: 20px; /* Adjust size as needed */
        border-radius: 4px; /* Optional: rounded corners */
    }
</style>